import React from "react"

import { images } from "../../config/image-definitions"
import BackgroundImage from "./BackgroundImage"
import ExpandableIcon from "./ExpandableIcon"
import SideCheckBox from "./SideCheckBox"
import SideRemoveButton from "./SideRemoveButton"

const OrganisationListItem = ({
    id,
    name,
    full_name,
    image_url,
    labels,
    labelColor,
    onRemove,
    onClick,
    shouldDisplayCheckmark,
    isAdded,
    isExpandable,
    isExpanded,
    dataCy,
    showImage = true,
    showLabels = true
}) => (
    <div
        className="list-group-item force-chrome-rerender"
        onClick={onClick ? onClick(id) : null}
        data-cy={dataCy}
    >
        {showImage && (
            <BackgroundImage
                classList={["list-group-item-thumb"]}
                imageUrl={image_url}
                defaultImageUrl={
                    id === "org_Public" ? (
                        images.publicOrganisation
                    ) : (
                        images.organisationPlaceholder
                    )
                }
                isThumbnail={true}
            />
        )}
        <div className="list-group-item-content">
            <h4>{name || full_name}</h4>
            {id !== "org_Public" &&
            !isExpanded && (
                <div className="tags">
                    {showLabels &&
                        labels &&
                        labels.map(label => (
                            <div
                                className={`tag-item ${labelColor || "grey"}`}
                                key={label}
                            >
                                {label}
                            </div>
                        ))}
                </div>
            )}
            {onRemove && <SideRemoveButton onClick={onRemove} />}
            {onClick &&
            shouldDisplayCheckmark && <SideCheckBox isAdded={isAdded} />}
        </div>
        {isExpandable && (
            <ExpandableIcon
                isExpanded={isExpanded}
                rotation={-90}
                onClick={onClick ? onClick(id) : null}
            />
        )}
    </div>
)

export default OrganisationListItem
